module.exports = __webpack_public_path__ + "static/media/special_4.e1327312.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/special/special_4.csv
// module id = 740
// module chunks = 0